import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const id = this.element.id;
    const title = this.element.getAttribute("data-title");

    import("highcharts/highstock").then(Highcharts => {
      Highcharts.chart(id, {
        time: { useUTC: false },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        credits: {
          enabled: false
        },
        title: {
          text: title
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || "black"
              }
            }
          }
        },
        series: [
          {
            name: "Percentage Volume",
            colorByPoint: true,
            data: JSON.parse(this.element.getAttribute("data-stats"))
          }
        ]
      });
    });
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/pie_chart_controller.js